import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';

import { SharedApplicationState } from '../../../state/shared-state.interface';
import { UserTokens } from '../../common/entities/user/user-tokens.entity';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private readonly WHITELISTED_URLS: string[] = ['mediahaven-rest-api/v2', 'workflow/api', 'portal-api/v2'];

    private readonly userTokens$: Observable<UserTokens>;

    constructor(public store: Store<SharedApplicationState>) {
        this.userTokens$ = this.store.select<UserTokens>(state => state.token.userTokens);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.userTokens$.pipe(
            take(1),
            mergeMap((token: UserTokens) => {
                const isWhitelistedUrl: boolean = this.WHITELISTED_URLS.some((url: string) =>
                    request.url.includes(url)
                );
                if (isWhitelistedUrl) {
                    const authenticatedRequest: HttpRequest<any> = this.appendAuthorizationToken(request, token);
                    return next.handle(authenticatedRequest);
                }

                return next.handle(request);
            })
        );
    }

    private appendAuthorizationToken(request: HttpRequest<any>, token: UserTokens): HttpRequest<any> {
        let authenticatedRequest: HttpRequest<any>;

        let headers: HttpHeaders = request.headers || new HttpHeaders();

        if (token?.access_token && token.token_type) {
            headers = headers.append('Authorization', `bearer ${token.access_token}`);
            authenticatedRequest = request.clone({ headers });
        } else {
            authenticatedRequest = request;
        }

        return authenticatedRequest;
    }
}
